export class LogsCreateRequest {
	id: number;
	message: string;
	stackTrace: string;
	logLevel: string;
	additionalInfo: string;
	type: string;
	callSite: string;
	clientTimeStamp: string;
	source: string;
	releaseVersion: string;
}
